<template>
  <div>
    <h1 class="text-center">{{ schema.$title }}</h1>

    <panel>
      <div class="row form-group">
        <school-picker class="col-md-6" :school-model="schema.data.school" />

        <w-input class="col-md-3" :model="schema.data.schoolYear" />

        <w-radio-list
          class="col-md-3"
          :model="schema.data.contestType"
          :values="contestTypes"
          :disabled="hasContests"
        />

        <w-radio-list
          v-if="schema.data.school.schoolName.$model && !schema.data.school.nodeId.$model"
          class="col-md-3"
          :model="schema.data.school.level"
          :values="schoolLevels"
          :disabled="hasContests"
        />
      </div>
    </panel>

    <template v-for="(studentDocument, index) in schema.childrenModels.$items">
      <collapse-student :key="'student_' + index" :schema="studentDocument.$item" />
    </template>

    <panel>
      <w-button class="btn-primary float-right" text="Dodaj ucznia" icon="fas fa-plus" @click="addStudent" />

      <w-error class="pt-2" :model="schema.childrenModels" />
    </panel>

    <panel :title="schema.data.principle.$title">
      <person :model="schema.data.principle" :has-address="false">
        <w-checkbox :model="schema.data.principle.rodo" />
      </person>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import WButton from '@/components/button/Button';
import Panel from '@/components/panel/Panel';
import { ow003PrezydenckiMixin } from '@/mixins/document/ow003Prezydencki';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';
import { tryParseInt } from '@/utils/number';
import { getProfileId } from '@/utils/profile';
import CollapseStudent from '../CollapseStudent';
import Person from '../Person';
import SchoolPicker from '../SchoolPickerPrezydencki';

// @vuese
// Formularz wzoru OW-003-Prezydencki
export default {
  components: { Panel, Person, CollapseStudent, SchoolPicker, ...components, WButton },
  mixins: [ow003PrezydenckiMixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },
  computed: {
    hasContests() {
      return this.schema.$model.childrenModels.some(child => child.data && child.data.contests.length);
    }
  },
  methods: {
    // @vuese
    // Dodaje subwniosek ucznia do listy
    addStudent() {
      this.schema.childrenModels.$addRow({
        parentId: tryParseInt(this.$route.params.parentId),
        creatorId: getProfileId()
      });
    }
  }
};
</script>
